import { FORM_CONTROL } from './formControlStyles';

/** Standard primary actions share the form control height. */
export const ACTION_BUTTON_HEIGHT = FORM_CONTROL.toggleMinHeight;

/** Sidebar actions match the account navigation rows. */
export const NAVIGATION_CONTROL_HEIGHT = ACTION_BUTTON_HEIGHT;

/** Standard actions and choice buttons share one size. */
export const actionButtonSizingSx = {
  width: 'fit-content',
  minWidth: 0,
  maxWidth: '100%',
  minHeight: ACTION_BUTTON_HEIGHT,
  px: 2.5,
  py: 1,
  fontSize: FORM_CONTROL.fontSize,
  fontWeight: 700,
  lineHeight: 1.5,
  textTransform: "none",
} as const;

/** Wizard footer actions retain their compact height and labels. */
export const stepButtonSizingSx = {
  ...actionButtonSizingSx,
  minHeight: 44,
  fontSize: 14,
  lineHeight: 1.25,
} as const;

export const compactButtonSizingSx = {
  ...actionButtonSizingSx,
  minHeight: { xs: 44, sm: 40 },
  px: { xs: 1.5, sm: 2 },
  py: 0.75,
  fontSize: { xs: 13, sm: 14 },
  lineHeight: 1.25,
} as const;

/** Library pills and view toggles match the compact wizard actions. */
export const LIBRARY_CONTROL_HEIGHT = stepButtonSizingSx.minHeight;

export const libraryButtonSizingSx = {
  ...stepButtonSizingSx,
  minHeight: LIBRARY_CONTROL_HEIGHT,
  px: { xs: 1.75, sm: 2.25 },
} as const;

/** Secondary actions and filters next to a card heading. */
export const cardPillSizingSx = {
  ...libraryButtonSizingSx,
  minHeight: 34,
  height: 34,
  px: 1.5,
  py: 0.5,
  fontSize: 13,
  borderRadius: 999,
  flexShrink: 0,
  whiteSpace: 'nowrap',
} as const;
